var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "header",
        [
          _c(
            "el-col",
            { attrs: { span: 18 } },
            [
              _c("el-row", [
                _c("span", [
                  _vm._v("模式：" + _vm._s(_vm.$route.params.modeDesc)),
                ]),
                _c("span", { staticClass: "ml-20" }, [
                  _vm._v("故事：" + _vm._s(_vm.$route.params.storyName)),
                ]),
                _c("span", { staticClass: "ml-20" }, [
                  _vm._v("角色：" + _vm._s(_vm.$route.params.role)),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 6 } },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.onSubmit("ruleForm")
                    },
                  },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        { ref: "ruleForm", attrs: { "label-width": "120px" } },
        _vm._l(_vm.paramMap, function (val, key) {
          return _c(
            "div",
            { key: key },
            [
              _c("div", { staticClass: "title" }, [_vm._v(_vm._s(key))]),
              _vm._l(val, function (item, index) {
                return _c(
                  "el-form-item",
                  { key: index, attrs: { label: item.name } },
                  [
                    _c("el-input", {
                      attrs: {
                        id: `textarea${key}${index}`,
                        type: "textarea",
                        placeholder: `请输入${item.name}`,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.changeTextarea(`textarea${key}${index}`)
                        },
                      },
                      model: {
                        value: item.value,
                        callback: function ($$v) {
                          _vm.$set(item, "value", $$v)
                        },
                        expression: "item.value",
                      },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }